export const CRYPTO_CURRENCY_INVESTMENT_MODE_AUTO = 'auto' as const

export const CRYPTO_CURRENCY_INVESTMENT_MODE_MANUAL = 'manual' as const
